export const getHasActiveElement = (target: Maybe<Element>) => {
  return target?.contains(document.activeElement);
};
